import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "text-big" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_3 = {
  key: 15,
  style: {"max-width":"650px","margin":"50px auto"}
}
const _hoisted_4 = {
  key: 16,
  style: {"max-width":"650px","margin":"50px auto"}
}
const _hoisted_5 = {
  key: 1,
  class: "page-placeholder"
}
const _hoisted_6 = {
  key: 0,
  class: "text-danger"
}

import { debug as d } from "debug";
import { computed, ref, watch } from "vue";
import useNotification, { CompletionNotification } from "../../composables/useNotification";
import { csContext } from "../../services/cs-context";
import CmsReport from "./cms-report.vue";
import TeamEffectivenessQuestionnairePage from "../team-effectiveness/team-effectiveness-questionnaire-page.vue";
import TeamEffectivenessReport from "../team-effectiveness/team-effectiveness-report.vue";
import CmsDevelopStepPage from "./cms-develop-step-page.vue";
import {
  CmsDocument,
  CmsDocumentTypes,
  CmsGoalCapturePage as CmsGoalCapturePageType,
  CmsPersonalPathway,
  CmsReportResource,
  CmsResourceData,
} from "../../services/cms/cms-type-definitions";
import cms from "../../services/cms/cms";
import ResourcePlaylist from "./resource-playlist.vue";
import ResourceThemesList from "../../components/cms/resource-themes-list.vue";
import ResourceThemesPage from "./resource-themes-page.vue";
import SessionWrapper from "../../components/sessions/session-wrapper.vue";
import CmsSession from "./cms-session.vue";
import PathwayWheel from "./pathway-wheel.vue";
import CmsTextPage from "./cms-text-page.vue";
import PersonalPathwayWheel from "./personal-pathway-wheel.vue";
import SmartJournal from "../../components/smart-journal/smart-journal.vue";
import CmsSmartTextBox from "../../components/cms/cms-smart-text-box.vue";
import CmsSmartCallout from "../../components/cms/cms-smart-callout.vue";
import CmsGoalCapturePage from "./cms-goal-capture-page.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cms-page',
  props: {
    uid: { default: null },
    type: { default: null }
  },
  setup(__props: any) {

const debug = d("cs.CmsPage");

const props = __props;

const doc = ref<CmsDocument | null>(null);

const notFound = ref(false);

const isTextPage = computed(() => {
  if (!doc.value) {
    return false;
  }

  return doc.value.type === CmsDocumentTypes.CmsResource;
});

const docIsASession = computed(() => {
  switch (doc.value?.type) {
    case CmsDocumentTypes.CmsSession:
    case CmsDocumentTypes.CmsSessionWithSlides:
    case CmsDocumentTypes.CmsPersonalPathwayStep:
    case CmsDocumentTypes.CmsTeamPathwayStep:
      return true;
    default:
      return false;
  }
});

const pageTheme = computed(() => {
  // Note that doc is not necessarily a CmsResource, we're just using it as a typing example.
  return (doc.value?.data as CmsResourceData)?.page_visual_theme;
});

const isSectional = computed(() => {
  return doc.value?.type === CmsDocumentTypes.CmsReport;
});

function notifyTeamLeader() {
  if (!doc.value) return;

  const teamId = csContext.currentTeam?.id;
  if (!teamId) return;

  const { createCompletionNotification } = useNotification();

  const notification: CompletionNotification = {
    userId: csContext.user.id,
    teamId,
    prismicDoc: doc.value,
  };

  createCompletionNotification(notification);
}

const lastType = ref<string | null>(null);
const lastUid = ref<string | null>(null);

async function changeDoc() {
  if (props.type && props.uid && (props.type !== lastType.value || props.uid !== lastUid.value)) {
    debug("CmsPage.changeDoc");

    lastType.value = props.type;
    lastUid.value = props.uid;
    try {
      doc.value = await cms.getByUid(props.type, props.uid);

      if (doc.value) {
        notifyTeamLeader();
        if (doc.value.type === CmsDocumentTypes.CmsLinkResource) {
          window.location.href = cms.linkResolver(doc.value);
          return;
        }

        notFound.value = false;
      } else {
        throw new Error("Doc not found");
      }
    } catch {
      doc.value = null;
      notFound.value = true;
    }
  }
}

watch(
  [() => props.type, () => props.uid],
  () => {
    changeDoc();
  },
  { immediate: true },
);

return (_ctx: any,_cache: any) => {
  return (
      (doc.value && doc.value.type === _ctx.type && doc.value.uid == _ctx.uid) || (_ctx.type === 'cms-smart-journal-page' && !_ctx.uid)
    )
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["cms-page", [pageTheme.value, isSectional.value ? 'sectional-page' : '']]),
        style: _normalizeStyle([!docIsASession.value ? { 'padding-bottom': '80px' } : ''])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (!!doc.value && isTextPage.value)
            ? (_openBlock(), _createBlock(CmsTextPage, {
                key: 0,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (_ctx.type === 'cms-resource-playlist')
            ? (_openBlock(), _createBlock(ResourcePlaylist, {
                key: 1,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (!!doc.value && _ctx.type === 'cms-report-page')
            ? (_openBlock(), _createBlock(CmsReport, {
                key: 2,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (!!doc.value && _ctx.type === 'cms-team-goal-capture-page')
            ? (_openBlock(), _createBlock(CmsGoalCapturePage, {
                key: 3,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (_ctx.type === 'cms-resource-theme')
            ? (_openBlock(), _createBlock(ResourceThemesList, {
                key: 4,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (_ctx.type === 'cms-resource-themes-page')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                _hoisted_2,
                (doc.value)
                  ? (_openBlock(), _createBlock(ResourceThemesPage, {
                      key: 0,
                      doc: doc.value
                    }, null, 8, ["doc"]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (!!doc.value && _ctx.type === 'cms-session-with-slides')
            ? (_openBlock(), _createBlock(SessionWrapper, { key: 6 }, {
                default: _withCtx(() => [
                  _createVNode(CmsSession, { doc: doc.value }, null, 8, ["doc"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.type === 'cms-pathway')
            ? (_openBlock(), _createBlock(PathwayWheel, {
                key: 7,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (!!doc.value && _ctx.type === 'cms-personal-pathway')
            ? (_openBlock(), _createBlock(PersonalPathwayWheel, {
                key: 8,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (_ctx.type === 'cms-team-effectiveness-review')
            ? (_openBlock(), _createBlock(TeamEffectivenessQuestionnairePage, {
                key: 9,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (_ctx.type === 'cms-report')
            ? (_openBlock(), _createBlock(TeamEffectivenessReport, {
                key: 10,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (!!doc.value && _ctx.type === 'cms-develop-page')
            ? (_openBlock(), _createBlock(CmsDevelopStepPage, {
                key: 11,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (!!doc.value && _ctx.type === 'cms-pathway-step')
            ? (_openBlock(), _createBlock(SessionWrapper, { key: 12 }, {
                default: _withCtx(() => [
                  _createVNode(CmsSession, { doc: doc.value }, null, 8, ["doc"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (!!doc.value && _ctx.type === 'cms-personal-pathway-step')
            ? (_openBlock(), _createBlock(SessionWrapper, { key: 13 }, {
                default: _withCtx(() => [
                  _createVNode(CmsSession, { doc: doc.value }, null, 8, ["doc"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.type === 'cms-smart-journal-page')
            ? (_openBlock(), _createBlock(SmartJournal, {
                key: 14,
                doc: doc.value
              }, null, 8, ["doc"]))
            : _createCommentVNode("", true),
          (_ctx.type === 'cms-smart-text-box')
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(CmsSmartTextBox, {
                  uid: doc.value ? doc.value.uid : ''
                }, null, 8, ["uid"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.type === 'cms-smart-callout')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(CmsSmartCallout, {
                  uid: doc.value?.uid ?? ''
                }, null, 8, ["uid"])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 6))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        (notFound.value)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_6, "Not found."))
          : _createCommentVNode("", true)
      ]))
}
}

})